import { request } from "./apiClient";
import { storeTokens } from "../lib/authSession";

export const authService = {
  login: ({ email, username, password }) =>
    request("/auth/login", { method: "POST", body: { email, username, password } }),

  googleLogin: ({ idToken }) =>
    request("/auth/google", { method: "POST", body: { idToken } }),

  me: (token) => request("/auth/me", { token }),

  changePassword: (token, { currentPassword, newPassword }) =>
    request("/auth/change-password", {
      method: "POST",
      token,
      body: { currentPassword, newPassword },
    }).then((data) => {
      // Server thu hồi các phiên khác và cấp phiên mới cho thiết bị này
      if (data?.token) storeTokens(data);
      return data;
    }),

  sendRegisterOtp: ({ fullName, email, password }) =>
    request("/auth/register/send-otp", {
      method: "POST",
      body: { fullName, email, password },
    }),

  verifyRegisterOtp: ({ email, otp }) =>
    request("/auth/register/verify-otp", {
      method: "POST",
      body: { email, otp },
    }),

  sendForgotPasswordOtp: ({ email }) =>
    request("/auth/forgot-password/send-otp", {
      method: "POST",
      body: { email },
    }),

  resetPasswordWithOtp: ({ email, otp, newPassword }) =>
    request("/auth/forgot-password/reset", {
      method: "POST",
      body: { email, otp, newPassword },
    }),
};

